import { VContainer } from 'vuetify/lib/components/VGrid';
import { VIcon } from 'vuetify/lib/components/VIcon';

var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c(VContainer, {
    staticClass: "ma-0 pa-0"
  }, [_c('div', {
    class: `outer-container ${_vm.showTransparencyGrid ? 'transparency-grid' : ''}`,
    on: {
      "click": _vm.addImage
    }
  }, [_c('img', {
    ref: "imageElement",
    staticClass: "image-class",
    attrs: {
      "src": _vm.imgSrc,
      "width": "100%"
    }
  }), _c('div', {
    staticClass: "overlay"
  }, [_c('div', {
    staticClass: "icon",
    style: `background: ${_vm.dark ? _vm.darkIconBg : _vm.lightIconBg}`
  }, [_c(VIcon, {
    attrs: {
      "large": "",
      "color": "#FFFFFF"
    }
  }, [_vm._v("fal fa-camera")])], 1)])]), _c('input', {
    ref: "fileInput",
    staticClass: "hide",
    attrs: {
      "type": "file",
      "accept": "image/x-png,image/jpeg,image/gif"
    },
    on: {
      "change": _vm.handleImageAdded
    }
  })]);
};
var staticRenderFns = [];
export { render, staticRenderFns };